import { mediaUrl } from "./media-url";

export const DEATH_EFFECT_MUSIC_TRACKS = Array.from({ length: 6 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");
  return { id: `death-effect-${number}`, url: mediaUrl(`/assets/audio/death-effect/death-effect-${number}.mp3`) };
});

export function deathEffectMusicUrl(trackId: string | undefined) {
  return DEATH_EFFECT_MUSIC_TRACKS.find((track) => track.id === trackId)?.url;
}

export function randomDeathEffectMusicTrackId(random = Math.random) {
  const sample = Math.max(0, Math.min(0.9999999999999999, random()));
  return DEATH_EFFECT_MUSIC_TRACKS[Math.floor(sample * DEATH_EFFECT_MUSIC_TRACKS.length)].id;
}
